import { IParentPlayerContact, IPlayerContactCandidate } from '../../../lib/types';

// Every contact on one player, as the server sees them: the parent's own row(s)
// plus the co-contacts those rows carry. Empty when no player is selected yet.
export function contactsForPlayer(contacts: IParentPlayerContact[], playerId?: string): IPlayerContactCandidate[] {
  if (!playerId) return [];
  const mine = contacts.filter((row) => row.playerId === playerId);
  return [...mine, ...((mine[0] && mine[0].otherContacts) || [])];
}
